var exports = {
  "LA": "xaee3c4fa--d28b63--seo-urls",
  "Gz": "xaee3c4fa--d28b63--seo-urls-dekstop",
  "Mv": "xaee3c4fa--d28b63--seo-urls__header",
  "qD": "xaee3c4fa--d28b63--seo-urls__header_text",
  "BU": "xaee3c4fa--d28b63--seo-urls__list",
  "yL": "xaee3c4fa--d28b63--seo-urls__item",
  "KP": "xaee3c4fa--d28b63--seo-urls__content",
  "gb": "xaee3c4fa--d28b63--seo-urls-mobile",
};

module.exports = exports;
